import { render, staticRenderFns } from "./billingCorporateDetailHistory.vue?vue&type=template&id=10a5d0eb&scoped=true"
import script from "./billingCorporateDetailHistory.vue?vue&type=script&lang=js"
export * from "./billingCorporateDetailHistory.vue?vue&type=script&lang=js"
import style0 from "./billingCorporateDetailHistory.vue?vue&type=style&index=0&id=10a5d0eb&prod&lang=css"
import style1 from "./billingCorporateDetailHistory.vue?vue&type=style&index=1&id=10a5d0eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5d0eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VRow,VSpacer})
